/**
 @author xiaoye
 @date 2020/4/10 7:53 下午
 */

import store from '@/store';
import Vue from 'vue'
import {comLegend, comColor} from "../../script/comChart";
import jsonVal from "./json/data.json";
let vm = new Vue();
let vuex = store.state;
export default {
    //类型
    type: 'line',
    //类别
    class: 'chart',
    //组件名称
    name: '折线图',
    //排序
    sort: 2,
    //是否在多维分析展示
    viewType:true,
    //图标
    iconImg: '/img/line.png',
    //基础配置
    option: {
        //最小维度数量
        minWDLength: 1,
        //最小度量数量
        minDLLength: 1,
        //最大维度数量
        maxWDLength: 1,
        //最大度量数量
        maxDLLength: 5,
        //高
        dp_height: 200,
        //宽
        dp_wight: 300,
        //最小高
        dp_min_height: 100,
        //最小宽
        dp_min_wight: 200,
        //是否展示维度配置
        isWdConfig: true,
        //是否展示度量配置
        isDlConfig: true,
        //是否展示JSON配置
        isJSONConfig: true,
        //是否展示公共配置
        isComConfig: true,
        //是否展示边框
        isComBorder: true,
    },
    // 子集展示的配置项
    chilCharts: [
        {
            name: '折线图',
            ordImg: '/img/line.png',
            bigImg: '/img/line.png',
            //默认配置
            chartParam: {},
            wdParam: {},
            dlParam: {
                stack: ''
            },
            //不展示的配置组件列表
            isNoModuleName:['极坐标配置','极坐标径向轴配置'],
        },
        {
            name: '面积图',
            ordImg: '/img/linearea.png',
            bigImg: '/img/linearea.png',
            //默认配置
            chartParam: {},
            wdParam: {},
            dlParam: {
                stack: ''
            },
            //不展示的配置组件列表
            isNoModuleName:['极坐标配置','极坐标径向轴配置'],
        },
        {
            name: '曲线图',
            ordImg: '/img/quxian.png',
            bigImg: '/img/quxian.png',
            //默认配置
            chartParam: {},
            wdParam: {},
            dlParam: {
                stack: ''
            },
            //不展示的配置组件列表
            isNoModuleName:['极坐标配置','极坐标径向轴配置'],
        },
        {
            name: '圆环图',
            ordImg: '/img/linepolar.png',
            bigImg: '/img/linepolar.png',
            //默认配置
            chartParam: {},
            wdParam: {},
            dlParam: {
                stack: ''
            },
            //不展示的配置组件列表
            isNoModuleName: ['X轴配置','Y轴配置'],
        },
        {
            name: '梯形图',
            ordImg: '/img/stepline.png',
            bigImg: '/img/stepline.png',
            //默认配置
            chartParam: {},
            wdParam: {},
            dlParam: {
                stack: '统计'
            },
            //不展示的配置组件列表
            isNoModuleName:['极坐标配置','极坐标径向轴配置'],
        },
    ],
    //维度组件
    wdComponent: null,
    //维度参数
    wdHandle(option) {
        return {}
    },
    //度量组件
    dlComponent: () => import('./dlParam/dlParam'),
    //度量参数
     //度量参数
    dlHandle(option) {
        return {
            //堆叠
            stack: '123',
            //颜色
            color: '',
            //自定义
            customColor: false,
            //数值
            label: {
                show: false,
            },
            //主次轴
            lTAxis: 0,
            //折线图配置
            line: {
                //线的类型
                type:'solid',
                //是否平滑显示
                smooth:false,
                // 线宽
                width:'1',
                //标记图形
                symbol:'circle',
                //图形大小
                symbolsize:'4',
                symbolrotate:'',
                symbolcolor:'',
                symbolborder:'',
                symbolWidth:'0',
                areashow:true,
                areaStyle:{
                    color:'',
                    shadowColor: 'rgba(0,202,149, 0.9)',
                    shadowBlur:20,
                }

            }
        }
    },
    //配置参数
    params(option) {
        return {
            //图例配置
            legend: {
                show: true,
                position: 'top',
                //字体
                font: {
                    color: vuex.dpType === 1 ? '#fff' : '#333',
                    size: 14,
                },
                 //间隔
                marInterval: 15,
                orient:'horizontal'
            },
            //轴线配置
            axios: {
                //主轴
                spind: {
                    show: true,
                    startVal: 0,
                    angle: 0,
                    color:'',
                },
                //次轴
                bout: {
                    show: true,
                    startVal: 0,
                    angle: 0,
                    //字体
                    font: {
                        show:true,
                        color: vuex.dpType === 1 ? '#fff' : '#333',
                        size: 12,
                    },
                },
                //X轴
                xAxios: {
                    show: true,
                    type:'category',
                    boundaryGap:true,
                    axisLine:{
                        show:true,
                        lineStyle:{
                            color: vuex.dpType === 1 ? '#fff' : '#333',
                            width: 1 ,
                            type: 'solid' ,
                        }
                    },
                    axisTick: {
                        show: true,
                        inside: false,
                    },
                    axisLabel: {
                        show: true,
                        fontSize: 12 ,
                        color: vuex.dpType === 1 ? '#fff' : '#333',
                        rotate: 0 ,
                    },
                    splitLine: {
                        show:true,
                        lineStyle: {
                            color: vuex.dpType === 1 ? ['#fff'] : ['#333'],
                            width: 1,
                            type:'solid'
                        }
                    },
                },
                //Y轴
                yAxios:{
                    yAxios: [{
                        show: true,
                        type:'value',
                        axisLine:{
                            show:true,
                            lineStyle:{
                                color: vuex.dpType === 1 ? '#fff' : '#333',
                                width: 1 ,
                                type: 'solid' ,
                            }
                        },
                        axisTick: {
                            show: true,
                            inside: false,
                        },
                        axisLabel: {
                            show: true,
                            fontSize: 12 ,
                            color: vuex.dpType === 1 ? '#fff' : '#333',
                            rotate: 0 ,
                        },
                        splitLine: {
                            show:true,
                            lineStyle: {
                                color: vuex.dpType === 1 ? ['#fff'] : ['#333'],
                                width: 1,
                                type:'solid'
                            }
                        },
                        min: 0,
                        startVal: 0,
                        angle: 0,
                    }],
                },
                font:{
                    color:vuex.dpType === 1 ? '#fff' : '#333',
                    size:12,
                    angle:0
                },
                //轴线颜色
                color: vuex.dpType === 1 ? '#fff' : '#333',

            },
            polar:{
                 radius:'75' ,
                     font:{
                     color:vuex.dpType === 1 ? '#fff' : '#333',
                         size:12,
                         angle:0
                 },
                 angle:0,
                     //轴线颜色
                     color: vuex.dpType === 1 ? '#fff' : '#333',
             },
            radiusAxis:{
                type: 'category',
                show: true,
                axisLabel: {
                    interval: 0,
                    show: true ,
                    color:vuex.dpType === 1 ? '#fff' : '#333',
                    fontSize:12,
                    rotate:0
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color:vuex.dpType === 1 ? '#fff' : '#333',
                    }
                },
                axisTick: {
                    show: true,
                    length: 5,
                    alignWithLabel: true,
                    lineStyle: {
                        color:vuex.dpType === 1 ? '#fff' : '#333',
                    }
                },
                splitLine: {
                    show: true,
                    lineStyle: {
                        color:vuex.dpType === 1 ? '#fff' : '#333',
                        width: 1,
                        type: "solid"
                    }
                },

            },
            angleAxis:{
                show: false,
                min: 0,
                max: 0,
                axisLabel: {
                    show: true,
                    color:vuex.dpType === 1 ? '#fff' : '#333',
                    fontSize: 20,
                    rotate: 10
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color:vuex.dpType === 1 ? '#fff' : '#333',
                    }
                },
                splitLine: {
                    show: true,
                    lineStyle: {
                        color:vuex.dpType === 1 ? '#fff' : '#333',
                        width: 1,
                        type: "solid"
                    }
                },
                axisTick: {
                    show: true,
                    length: 5,
                    alignWithLabel: true,
                    lineStyle: {
                        color:vuex.dpType === 1 ? '#fff' : '#333',
                    }
                },
            },

        }
    },
    //右侧图表配置组件列表
    configModule: [
        {
            name: '图例配置',
            component: () => import('../../comConfig/comLegend/comLegend.vue')
        },
        {
            name: 'X轴配置',
            component: () => import('../../comConfig/axios/axios.vue')
        },
        {
            name: 'Y轴配置',
            component: () => import('../../comConfig/yAxios/yAxios.vue')
        },
        {
            name: '极坐标配置',
            component: () => import('../../comConfig/polar/polar.vue')
        },
        {
            name: '极坐标径向轴配置',
            component: () => import('../../comConfig/polar/radiusAxis.vue')
        },

    ],
    JSONData: {
        //静态数组
        listDaVal: jsonVal,
        //接口参数
        params: {
            //维度
            wd: ['维度'],
            //度量
            dl: ['度量1', '度量2']
        },
        //引用的组件
        jsonPonent: () => import('./json/json'),
    },
    //静态转换数据回调
    JSONRender(json, chart, nowChart, viewDP) {
        try {
            let setChart = chart.setting;
            let params = nowChart.comParam.JSONData.params;
            let dl = params.dl;

            let wd = params.wd;
            let dlStyParam = setChart.dlStyParam;
            let wdStyParam = setChart.wdStyParam;
            let head = {
                listWD: [],
                listZB: []
            };
            let dt = JSON.parse(json);
            wd.map((item, index) => {
                if (!item) {
                    return;
                }
                let count = 0;
                for (let i of setChart.wdList) {
                    if (i.name === item) {
                        count = 1;
                        break;
                    }
                }
                head.listWD.push({
                    alias: item,
                    filed: item
                });
                if (count === 0) {
                    let data = {
                        name: item,
                        config: JSON.parse(JSON.stringify(viewDP.comWDConfig)),
                        params: JSON.parse(JSON.stringify(wdStyParam[index] || nowChart.comPonent.wdParams))
                    };
                    data.config.alias = item;
                    setChart.wdList.push(data)
                }
            });
            dl.map((item, index) => {
                if (!item) {
                    return;
                }
                let count = 0;
                for (let i of setChart.dlList) {
                    if (i.name === item) {
                        count = 1;
                        break;
                    }
                }
                head.listZB.push({
                    alias: item,
                    filed: item
                });
                if (count === 0) {
                    let data = {
                        name: item,
                        config: JSON.parse(JSON.stringify(viewDP.comDLConfig)),
                        params: JSON.parse(JSON.stringify(dlStyParam[index] || nowChart.comPonent.dlParams))
                    };
                    data.config.alias = item;
                    setChart.dlList.push(data)
                }
            });
            let JkData = {
                dataTabel: {
                    dt: dt,
                    head: head
                },
                totalCount: dt.length
            };
            chart.data = JkData;
        } catch (e) {
            chart.data = {};
        }
    },
    renderBefore(chart, nowChart,dom) {
        let echart = echarts.init(dom);
        echart.dispose()
        echart = null;
        if (nowChart.name === '圆环图') {
            nowChart.comConfig.gridType = 1;
        } else {
            nowChart.comConfig.gridType = 0;
        }
    },
    //渲染
    rendering(chart, nowChart, dom) {
        let dataAll = JSON.parse(JSON.stringify(chart.data.dataTabel));
        //度量维度配置
        let config = chart.setting;
        // 图表轴
        let comConfig = nowChart.comConfig;
        let echart = echarts.init(dom);
        let params = config.params;
        // 维度配置参数
        let wdParams = config.wdList;
        // 度量配置参数
        let dlParams = config.dlList;
        //维度名称
        let wd = dataAll.head.listWD;
        //度量
        let dl = dataAll.head.listZB;
        //颜色
        let colorList = JSON.parse(JSON.stringify(comColor(comConfig.colorIndex)));
        //数据
        let dataVal = dataAll.dt;

        dataVal.map((item, index) => {
            let da = {};
            for (let i in item) {
                da[i.toLowerCase()] = item[i];
            }
            dataVal[index] = da;
        });

        //
        let legendList = [];

        if (dataAll.dt.length > comConfig.valLength) {
            dataAll.dt.length = nowChart.comConfig.valLength;
        }

        //获取度量数据
        let dlVal = [];
        dl.map((i, index) => {
            let configDL = {};
            dlParams.map((c) => {
                if (c.name === i.filed) {
                    configDL = c;
                }
            });
            let node = {
                value: [],
                filedNmae: i.filed,
                aliasNmae: i.alias,
                config: configDL,
            };
            node.value = dataVal.map((item) => {
                if (configDL.params.customColor) {
                    colorList[index] = configDL.params.color;
                    return {
                        value: item[i.alias],
                        itemStyle: {
                            color: configDL.params.color
                        }
                    } || 0
                } else {
                    return item[i.alias] || 0
                }
            });
            dlVal.push(node);
            legendList.push(i.alias);
        });

        //获取维度数据
        let wdVal = [];
        wdVal = dataVal.map((item) => {
            return item[wd[0].alias];
        });
        //x轴 自定义
        let xAxisCustom = params.axios.xAxios;
        xAxisCustom.data = wdVal;
        //y轴 自定义
        let yAxisCustom = params.axios.yAxios.yAxios;
        //定义角度值最大值
        if (nowChart.name === '圆环图') {
            let maxArr = [];
            dlVal.map((item) => {
                var getMax = Math.max.apply(Math, item.value);
                maxArr.push(getMax)
            })
            var getMaxArr = Math.max.apply(Math, maxArr);
            if( params.angleAxis.max < getMaxArr){
                params.angleAxis.max = getMaxArr;
            }else{
                params.angleAxis.max = params.angleAxis.max;
            }
        }
        //判断数据是否超过15条  grid专用
        let isDataLengthToNum = function () {
            let min = 15;
            if (!dataAll.dt) return false;
            if (dataAll.dt.length > min) {
                return true;
            } else {
                return false;
            }
        };

        let option = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    label: {
                        show: true
                    }
                }
            },
            grid: {
                top: comConfig.grid.top + '%',
                bottom: comConfig.grid.bottom + '%',
                left: comConfig.grid.left + '%',
                right: comConfig.grid.right + '%',
                containLabel: true
            },
            legend: comLegend(params.legend, legendList),
            xAxis: nowChart.name === '圆环图' ? null : (nowChart.name === '条形图' ? yAxisCustom : xAxisCustom),
            yAxis: nowChart.name === '圆环图' ? null : (nowChart.name === '条形图' ? xAxisCustom : yAxisCustom),
            color: colorList,
            series: (() => {
                let list = [];
                dlVal.map((item) => {
                    let dlParam = item.config.params;
                    list.push({
                        type:this.type,
                        // data: [820, 932, 901, 934, 1290, 1330, 1320],
                        data: item.value,
                        name: item.aliasNmae,
                        barMaxWidth: '30',
                        barGap: '30%',
                        // yAxisIndex: nowChart.name === '双轴图' ? dlParam.lTAxis : null,
                        label: {
                            show: dlParam.label.show || false,
                            position: 'top',
                            formatter: function (data) {
                                return data.value;
                            },
                        },
                        symbol:dlParam.line.symbol,
                        symbolSize:dlParam.line.symbolsize,
                        symbolRotate:dlParam.line.symbolrotate,
                        itemStyle:{
                            borderColor:dlParam.line.symbolborder,
                            borderWidth:dlParam.line.symbolWidth,
                        },
                        lineStyle:{
                            width:dlParam.line.width,
                            type: dlParam.line.type,
                        },
                        step:nowChart.name === '梯形图' ? true : false,
                        smooth: dlParam.line.smooth || false,
                        areaStyle: nowChart.name === '面积图' ? {
                            color:dlParam.line.areaStyle.color,
                            shadowColor:dlParam.line.areaStyle.shadowColor,
                            shadowBlur:10,
                        } : null,
                        stack: dlParam.stack,
                        coordinateSystem: nowChart.name === '圆环图' ? 'polar' : 'cartesian2d',
                    });
                    if(list[0].areaStyle!=null){
                        dlParam.line.areashow=true;
                    }else{
                        dlParam.line.areashow=false;
                    }
                });

                return list;
            })()
        };
        if (nowChart.name === '圆环图') {
            option['polar'] = {
                radius:params.polar.radius+'%' ,
                center: [comConfig.circle.left + '%', comConfig.circle.top + '%'],
            };
            option['radiusAxis'] = params.radiusAxis;
            option['radiusAxis'].data = wdVal;
            option['angleAxis'] = params.angleAxis;
        }
        echart.clear();
        echart.setOption(option);
        let g_clickTime = null;
        let g_TimeFn = null;
        let g_onItemName = '';
        echart.off('click') //解决重复点击
        echart.on('click', function (params) {
            let myDate = new Date();
            if (g_clickTime === null) {
                g_clickTime = myDate.getMilliseconds();
                g_onItemName = params.name;
                g_TimeFn = setTimeout(function () {
                    window.localStorage.setItem('softContent', params.name) //存值
                    window.localStorage.setItem('softContent1', params.name)
                    echart.setOption(option);
                    xz();
                    g_clickTime = null;
                }, 300);
            } else {
                clearTimeout(g_TimeFn);
                if (Math.abs(myDate.getMilliseconds() - g_clickTime) < 300 && g_onItemName === params.name) {
                    // 双击操作
                    window.localStorage.setItem('dbl', params.name) //存值
                    sz();
                }
                g_clickTime = null;
            }
        });
        echart.resize()
        echart.resize();
    }
}
